<template>
    <div>
        <div class="whiteHeader whiteHeader--narrow border-to" id="configurator-resume">
            <div class="container position-relative">
                <div class="whiteHeader__inner">
                    <h2 class="title mb-1">{{$t('components.ConfiguratorResume.resumeTitle')}}</h2>
                    <p class="mb-0">{{$t('components.ConfiguratorResume.itemsWillBeIsertedToBasket')}}</p>
                </div>
            </div>
        </div>

        <div class="l-white">
            <div class="container">
                <configurator-resume-set :key="set.collectionId" :set="set" v-for="set in sets"></configurator-resume-set>

                <configurator-resume-package></configurator-resume-package>

                <div class="text-right py-3">
                    <div class="small-title mb-5">
                        <span class="mr-2">{{ $t("components.ConfiguratorResume.totalPrice") }}</span>
                        <strong v-if="totalDiscountPrice">{{ $nf(totalDiscountPriceWithVat, 'currency' + currencyCode, 'cs-CZ') }}</strong>
                    </div>
                    <a @click.prevent="addToBasket" class="btn btn--cta btn--big" href="#">
                        <svg class="ico ico--medium">
                            <use xlink:href="#cart"/>
                        </svg>
                        {{ $t("components.ConfiguratorResume.insertToBasket") }}
                    </a>
                </div>

                <add-to-basket-popup
                        :show="showAddToBasketPopup"
                        @cancel=""
                        @toShop="redirectToShop()"
                        @toBasket="redirectToBasket()"
                ></add-to-basket-popup>
            </div>
        </div>
    </div>
</template>

<script>
    import AddToBasketPopup from "./AddToBasketPopup";
    export default {
        data: function() {
            return {
                showAddToBasketPopup: false
            };
        },
        components: {AddToBasketPopup},
        computed: {
            sets: function () {
                return this.$store.getters.getResumeSets;
            },
            currency: function () {
                return this.totalDiscountPrice.currency.htmlString;
            },
            currencyCode: function () {
                return this.totalDiscountPrice.currency.code;
            },
            totalDiscountPriceWithVat: function () {
                return this.totalDiscountPrice.priceWithVat;
            },
            totalDiscountPrice: function () {
                const store = this.$store;
                let totalPrice = this.sets.reduce(
                    function(totalPriceHandler, set) {
                        let price = set.items.reduce(
                            function (total, product) {
                                if(product.isCustom) {
                                    //Add custom price to total
                                    total.priceWithVat +=
                                        product.quantity *
                                        product.variantInfo.price.priceWithVat;
                                    total.currency = product.variantInfo.price.currency;
                                    return total;
                                } else {
                                    total.priceWithVat +=
                                        product.quantity *
                                        product.variantInfo.price.priceWithoutVat *
                                        (product.variantInfo.price.vatRate.rate / 100 + 1);
                                    total.currency = product.variantInfo.price.currency;
                                    return total;
                                }
                            },
                            {priceWithVat: 0}
                        );
                        if (set.collectionId == store.getters.currentCollectionId) {
                            var selectedSet = store.getters.getSelectedSet;
                            if (selectedSet) {
                                price.priceWithVat =
                                    price.priceWithVat -
                                    (selectedSet.price.priceWithVat -
                                        selectedSet.discountPrice.priceWithVat);
                            }
                        }
                        let packQuantity = store.getters.packQuantity(set.collectionId);
                        totalPriceHandler.priceWithVat += price.priceWithVat * packQuantity;
                        totalPriceHandler.currency = price.currency;
                        return totalPriceHandler;
                    },
                    {priceWithVat: 0}
                );
                if (totalPrice.hasOwnProperty("currency")) {
                    return totalPrice;
                }
                return null;
            }
        },
        methods: {
            addToBasket: function () {
                const that = this;
                this.$store.dispatch(
                    "addConfiguratorToBasket",
                    {}
                    ).then(function() {
                        that.showAddToBasketPopup = true;
                    });
            },
            redirectToBasket: function () {
                window.location.href = URLSource.basket;
            },
            redirectToShop: function () {
                window.location.href = URLSource.allProducts;
            },
        }
    };
</script>
